import { ErpDiv } from './ErpHtml';
import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface KpiGridProps {
  children?: ReactNode;
  className?: string;
}

const _KpiGrid: React.FC<KpiGridProps> = ({ children, className }) => {
  return (
    <ErpDiv data-slot="kpi-grid" className={cn('flex min-w-0 flex-wrap gap-4 mb-6 [&>*]:min-w-0 [&>*]:max-w-full [&>*]:flex-[1_1_14rem]', className)}>
      {children}
    </ErpDiv>
  );
};

export const KpiGrid = React.memo(_KpiGrid);
